var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"level-text",class:[_vm.describe.desc ? 'margin-bottom-6' : '']},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.describe.label))]),_c('span',{staticClass:"text-val",style:({ color: _vm.describe.color })},[_vm._v(" "+_vm._s(_vm.describe.text || "-")+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }